import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Button, Icon, Segment } from "semantic-ui-react";

import { findProducts } from "../../../../../reducer/actions";
import { getProducts } from "../../../../../reducer";

import SearchProduct from "../../SearchProduct";
import ProductsTable from "../../ProductsTable";

import { getTranslate } from "react-localize-redux/lib/index";

const inlineStyle = { marginTop: "10px" };

class Search extends Component {

    constructor(props) {
        super(props);

        this.state = {
            requestType: null
        };
    }

    render() {

        return <div>
            {!this.state.requestType && <div>
                <Button color='teal' style={inlineStyle} size='huge' fluid onClick={() => {
                    this.props.onProductSelect({
                        requestType: "create",
                        unitID: 9
                    });
                }}><Icon name='add'/>{this.props.translate("tools.general.create")}</Button>

                <Button color='yellow' style={inlineStyle} icon size='huge' primary fluid
                        onClick={() => {
                            this.setState({ requestType: "edit" });
                        }}><Icon name='edit'/>{this.props.translate("tools.general.mutation")}
                </Button>

                <Button positive style={inlineStyle} icon size='huge' primary fluid onClick={() => {
                    this.setState({ requestType: "newVintage" });
                }}><Icon name='copy'/>{this.props.translate("tools.general.newVintage")}</Button>

                <Button color='teal' style={inlineStyle} size='huge' fluid onClick={() => {
                    this.props.onProductSelect({
                        requestType: "newQuoteProduct",
                        unitID: 9
                    });
                }}><Icon name='add'/>{this.props.translate("tools.general.newQuoteProduct")}</Button>

            </div>
            }
            {this.state.requestType &&
            <div>
                <SearchProduct onSearch={(code) => {
                    this.init(code);
                }}/>

                {this.props.products && this.props.products.length > 0 &&
                <Segment>
                    <ProductsTable productSelected={(product) => {
                        if (!product.requestType) {
                            product.requestType = this.state.requestType;
                        }
                        this.props.onProductSelect(product);
                    }}/>
                </Segment>

                }
            </div>
            }
        </div>;
    }

    init(code) {
        this.loadProduct(code);
    }

    loadProduct(code) {
        this.props.findProducts(code);
    }

}

Search.propTypes = {
    onProductSelect: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    products: getProducts(state.tools)
});


const mapDispatchToProps = (dispatch) => {
    return ({
        findProducts: (code) => (dispatch(findProducts(code)))
    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Search);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/Search/index.js